<template>
    <main id="main">
        <div class="bg"></div>
        <div class="list_box">
            <p class="count">共检索到{{ count }}条数据</p>
            <ul>
                <li class="list_li" v-for="(item, index) in list" v-bind:key="index">
                    <p class="title" @click="getDetail(item.pmid, index)" v-html="index + 1 + ',' + item.title"></p>
                    <p class="source"><span>来源：</span>{{ item.source }}</p>
                    <p class="pmid"><span>PMID：</span>{{ item.pmid }}</p>
                </li>
            </ul>
            <div class="loading" v-if="loading">
                <van-loading type="spinner" size="30px" />
            </div>
        </div>
    </main>
</template>
<script>
import { Dialog, Toast } from "vant";
export default {
    name: "list",
    components: {
        [Dialog.Component.name]: Dialog.Component
    },
    data() {
        return {
            finished: false,
            params: {},
            list: [],
            count: 0,
            pageurl: "",
            page: 1,
            loading: true,
            // condition:''
            tbl: "",
            rekey: ""
        };
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "", iconType: true });
        this.params = this.$route.query;
        //pico
        this.$post("https://pico.yuntsg.com/pico/search", this.$qs.stringify(this.params)).then((res) => {
            if (res.code === 0) {
                this.count = res.data.total;
                this.pageurl = res.data.pageUrl;
                this.list = res.data.list;
                this.rekey = res.data.rekey;
                this.loading = false;
                Toast({ duration: 5000, forbidClick: true, message: "最新更新的数据可能导致pico有数据，但是Pubmed没有数据。" });
            } else {
                Dialog({ message: res.msg });
            }
        });

        let that = this;
        window.onscroll = function() {
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (scrollTop !== 0 && that.$route.path === "/picolist" && !that.loading) {
                if (Math.ceil(scrollTop + windowHeight) == scrollHeight || Math.floor(scrollTop + windowHeight) == scrollHeight) {
                    //写后台加载数据的函数
                    that.loading = true;
                    that.searchPage();
                }
            }
        };
    },
    methods: {
        //详情
        getDetail(pmid, index) {
            let tbl = "";
            if (this.list[index].tbl) {
                tbl = this.list[index].tbl;
                sessionStorage.setItem("tbl", tbl);
            } else {
                sessionStorage.removeItem("tbl");
            }
            this.$router.push({ path: "/picodetail", query: { pmid } });
        },
        //分页
        searchPage() {
            let page = this.page++;
            this.$post(
                "https://pico.yuntsg.com/pico/search-page?page=" + page + "&rekey=" + this.rekey + "&pageurl=" + encodeURIComponent(this.pageurl),
                ""
            ).then((res) => {
                if (res.code === 0) {
                    if (res.data.list.length !== 0) {
                        this.count = res.data.total;
                        this.pageurl =
                            res.data.pageUrl != "" && res.data.pageUrl != null && res.data.pageUrl != undefined ? res.data.pageUrl : this.pageurl;
                        this.list = this.list.concat(res.data.list);
                        this.loading = false;
                    } else {
                        Dialog({ message: "暂无数据！" });
                        this.page--;
                        this.loading = false;
                    }
                } else {
                    Dialog({ message: res.msg });
                    this.loading = false;
                }
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        // 进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
        if (to.name === "picodetail") {
            if (!from.meta.isKeepAlive) {
                from.meta.isKeepAlive = true; // 当我们进入到C时开启B的缓存
            }
            next();
        } else {
            from.meta.isKeepAlive = false;
            this.$vnode.parent.componentInstance.cache = {};
            this.$vnode.parent.componentInstance.keys = [];
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    }
};
</script>

<style scoped>
.bg {
    height: 12px;
    background-color: #f3f3f3;
}

ul {
    padding: 0;
}

.list_box {
    width: 95%;
    margin: 0 auto;
    display: table;
}

.list_box ul,
.list_li {
    width: 100%;
    height: auto;
    display: table;
}

.list_li {
    padding: 10px 0;
    border-bottom: 1px solid #e4e4e4;
}

.title {
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 25px;
    color: #1076be;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: normal !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.source,
.pmid {
    font-size: 16px;
    line-height: 25px;
    color: #989898;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: normal !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.source span,
.pmid span {
    color: black;
}

.count {
    margin-top: 10px;
    font-size: 16px;
    line-height: 35px;
}

.loading {
    width: auto;
    margin: 10px auto;
    height: auto;
}

.loading div {
    text-align: center;
}
</style>
